import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const Pagination = ({
  table, sizePerPage, maxPages = 5,
}) => {
  const totalRows = table.getFilteredRowModel().rows.length;
  const { pageIndex } = table.getState().pagination;
  const currentPage = pageIndex + 1;
  const isFirstPage = currentPage === 1;

  const currentFirstItem = currentPage * table.getState().pagination.pageSize - (sizePerPage - 1);

  const pages = useMemo(() => {
    const result = [];
    let startFrom = currentPage - 2;
    let offset = 2;
    if (currentPage - 3 < 0) {
      startFrom = 1;
      offset = 0;
    }

    if (table.getPageCount() > maxPages) {
      if (table.getPageCount() - currentPage < 2) {
        startFrom = currentPage - 3;
        offset = 0;
      }

      if (table.getPageCount() - currentPage === 0) {
        offset = 0;
        startFrom = currentPage - 4;
      }
    }

    for (let i = startFrom; i < currentPage + (maxPages - offset); i++) {
      if (i > table.getPageCount()) break;
      result.push(i);
    }
    return result;
  }, [table.getPageCount(), pageIndex]);

  const getFinalCount = () => {
    const count = sizePerPage * currentPage;
    if (count > totalRows) return totalRows;
    return count;
  };

  return (
    <>
      <div className="col-md-6 col-xs-6 col-sm-6 col-lg-6">
        {`Showing rows ${
          currentFirstItem <= totalRows ? currentFirstItem : totalRows
        } to ${getFinalCount()} of ${totalRows}`}
      </div>
      <div className="react-bootstrap-table-pagination-list col-md-6 col-xs-6 col-sm-6 col-lg-6">
        <ul className="pagination">
          {currentPage >= 4 && (
            <li className="page-item">
              <a
                href="#"
                className="page-link"
                onClick={() => table.setPageIndex(0)}
              >
                {'<<'}
              </a>
            </li>
          )}
          {!isFirstPage && (
            <li className="page-item">
              <a
                href="#"
                className="page-link"
                onClick={() => table.previousPage()}
              >
                {'<'}
              </a>
            </li>
          )}

          {pages.map(page => (
            <li
              className={`page-item ${currentPage === page ? 'active' : ''}`}
              key={`page_${page}`}
            >
              <a
                href="#"
                onClick={() => table.setPageIndex(page - 1)}
                className="page-link"
              >
                {page}
              </a>
            </li>
          ))}

          {table.getCanNextPage() && (
            <li className="page-item">
              <a
                href="#"
                className="page-link"
                onClick={() => table.nextPage()}
              >
                {'>'}
              </a>
            </li>
          )}

          {table.getPageCount() > 5
            && table.getCanNextPage()
            && table.getPageCount() - (currentPage + 3) > 0 && (
              <li className="page-item">
                <a
                  href="#"
                  className="page-link"
                  onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                >
                  {'>>'}
                </a>
              </li>
          )}
        </ul>
      </div>
    </>
  );
};

Pagination.propTypes = {
  table: PropTypes.shape({
    getState: PropTypes.func,
    previousPage: PropTypes.func,
    getCanNextPage: PropTypes.func,
    nextPage: PropTypes.func,
    getPageCount: PropTypes.func,
    setPageIndex: PropTypes.func,
    getCoreRowModel: PropTypes.func,
    getFilteredRowModel: PropTypes.func,
  }).isRequired,
  maxPages: PropTypes.number,
  sizePerPage: PropTypes.number.isRequired,
};

export default Pagination;
